import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

/**
 * Z czego wolno złożyć imię i nazwisko. `\p{L}` to litera DOWOLNEGO alfabetu, a `\p{M}`
 * znak diakrytyczny dopisany osobno — bez nich reguła odrzucałaby nazwiska cyrylicą
 * czy greką, a aplikacja mówi w dwudziestu językach. `\p{N}` — cyfry, bo konta urządzeń
 * nazywa się np. „Opaska Insider 5" / IMEI.
 */
const NAME_CHARS = /^[\p{L}\p{M}\p{N} .'-]+$/u;

const NO_DOUBLE_SPACE = Validators.pattern(/^((?!\s{2,}).)*$/);

export function personNameChars(control: AbstractControl) {
  const value = control.value;

  if (typeof value !== 'string' || value === '') {
    return null;
  }

  return NAME_CHARS.test(value) ? null : { checkNameChars: true };
}

export function singleWordLength(control: AbstractControl) {
  const value = control.value;

  if (typeof value !== 'string') {
    return null;
  }

  const words = value.split(' ');

  for (let i = 0; i < words.length; i++) {
    if (words[i].length > 20) {
      return { checkLengthName: true };
    }
  }

  return null;
}

// Edycja nie egzekwuje zestawu znaków: w bazie są konta założone poza tą aplikacją, z
// cyframi w nazwisku (opiekun „123 123"), a wstecz reguła blokowałaby na nich zapis
// czegokolwiek. Kolejność jest kontraktem — ValidateErrorsComponent pokazuje PIERWSZY błąd.
export const FIRST_NAME_EDIT_VALIDATORS: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(2),
  Validators.maxLength(30),
  NO_DOUBLE_SPACE,
  singleWordLength
];

export const LAST_NAME_EDIT_VALIDATORS: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(2),
  Validators.maxLength(30),
  NO_DOUBLE_SPACE,
  singleWordLength
];

export const FIRST_NAME_VALIDATORS: ValidatorFn[] = [...FIRST_NAME_EDIT_VALIDATORS, personNameChars];
export const LAST_NAME_VALIDATORS: ValidatorFn[] = [...LAST_NAME_EDIT_VALIDATORS, personNameChars];
